import React, { lazy, useEffect } from "react";
import { Badge } from "antd";
import { getCompanyId } from "apis/user";
import { setRequestToken } from "pages/myutils/request";
import * as qs from "query-string";
// import { getInformOutLines } from "apis/notice";
import { baseUrl } from "utils";
import $ from "jquery";
import cookies from "js-cookie";

const { axios } = window;

const { companyid, token } = qs.parse(window.location.search);
const pages = {
  prefix: ["/user", "/index"],
  init: function Init() {
    useEffect(() => {
      // 工作台有自己的逻辑处理 ， 所以刨除消息中心不需要企業id
      // console.log(window.location.pathname !== "/user/workbench/home");
      if (
        window.location.pathname !== "/user/workbench/home" &&
        window.location.pathname.indexOf("/user/notice") === -1
      ) {
        getCompanyId().then(datas => {
          // console.log(datas);
          if (datas.id > 0 && companyid * 1 !== datas.id) {
            window.location.href =
              window.location.pathname + "?companyid=" + datas.id;
          } else if (datas.id < 0 && window.location.pathname !== "/index") {
            // <Redirect to="/index" />;
            window.location.href = "/user/workbench/home";
          }
        });
      }
    }, []);
    return null;
  },
  pages: [
    {
      path: "/user/workbench",
      name: "工作台",
      children: [
        {
          path: "/user/workbench/home",
          name: "工作台",
          component: lazy(() => import("./workbench/home"))
        },
        {
          path: "/user/workbench/visitor",
          name: "访问员",
          noNav: true,
          component: lazy(() => import("./workbench/home/visitor"))
        },
        {
          path: "/user/workbench/agent",
          name: "代理商库",
          noNav: true,
          component: lazy(() => import("./workbench/home/agent"))
        },
        {
          path: "/user/workbench/balance",
          name: "结算中心",
          noNav: true,
          component: lazy(() => import("./workbench/home/balance"))
        }
      ]
    },
    {
      path: "/user/wallet",
      name: "我的钱包",
      noNav: false,
      children: [
        {
          path: "/user/wallet/list",
          name: "账户记录",
          component: lazy(() => import("./wallet/walletList"))
        },
        {
          path: "/user/wallet/textmessage",
          name: "短信管理",
          component: lazy(() => import("./wallet/walletList/textmess"))
        },
        {
          path: "/user/wallet/yinlianFirst",
          name: "银联第一次提现",
          noNav: true,
          component: lazy(() =>
            import("./wallet/walletList/yinlianWithdrawal/firstWithdrawal")
          )
        },
        {
          path: "/user/wallet/yinlianSecond",
          name: "银联第二次提现",
          noNav: true,
          component: lazy(() =>
            import("./wallet/walletList/yinlianWithdrawal/secondWithdrawal")
          )
        },
        {
          path: "/user/wallet/success",
          name: "银联提现成功",
          noNav: true,
          component: lazy(() =>
            import("./wallet/walletList/yinlianWithdrawal/withdrawalSuccess")
          )
        }
      ]
    },
    {
      path: "/user/notice",
      name: "站内信息",
      noNav: true,
      children: [
        {
          path: "/user/notice/sys",
          name: "系统通知",
          component: lazy(() => import("./notice/sys"))
        },
        {
          path: "/user/notice/message",
          name: "消息通知",
          component: lazy(() => import("./notice/message"))
        },
        {
          path: "/user/notice/dealt",
          name: "待办通知",
          component: lazy(() => import("./notice/dealt"))
        },
        {
          path: "/user/notice/more/:ids",
          name: "通知详情",
          noNav: true,
          component: lazy(() => import("./notice/sys/sysContent"))
        }
      ]
    }
  ],
  startPage: ""
};

if (window.location.pathname.indexOf("mymymanager") === -1) {
  if (token) {
    setRequestToken(token);
    cookies.set("shorcuts", token);
  }
  axios
    .get(`/customer/userInfo`, { params: { token: cookies.get("shorcuts") } })
    .then(function(data) {
      if (data.status !== 200) {
        return;
      }
      if (data.data.companySpecialAccount) {
        pages.pages[1].noNav = true;
      }
    });
  $.ajax({
    url:
      baseUrl +
      "/inform/informOutLines?token=" +
      (token || cookies.get("shorcuts")),
    async: false,
    withCredentials: true,
    success: data => {
      pages.pages[2].children[0].name = (
        <Badge count={data.systemInformsCount} offset={[20, 7]}>
          <p>系统通知</p>
        </Badge>
      );
      pages.pages[2].children[1].name = (
        <Badge count={data.messageInformsCount} offset={[20, 7]}>
          <p>消息通知</p>
        </Badge>
      );
      pages.pages[2].children[2].name = (
        <Badge count={data.todoInformsCount} offset={[20, 7]}>
          <p>待办通知</p>
        </Badge>
      );
    }
  });
  // getInformOutLines({
  //   token: cookies.get("shorcuts") || token
  // }).then(data => {
  //   console.log(data);
  // });
}

pages.startPage = pages.pages[0].path;
export default pages;
